import { render } from "./getting-started.md?vue&type=template&id=1d43f072"
import script from "./getting-started.md?vue&type=script&lang=js"
export * from "./getting-started.md?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__